import {UserConstants} from '../constants';
import { configAxios } from '../../utils/ConfigAxios';


export const load_UserDetails = (req) => (dispatch) => {
        // var req = {
        //     Keyword: "",
        //     Alphabet: null,
        //     DepartmentName: "",
        //     JobTitle: "",
        //     Location: "",
        //     ReportingManagerId: "",
        //     IsActive: true,
        //     Page: 1,
        //     ResultsPerPage: 6,
        // }
        configAxios.post(`/employees/search`,req)
            .then(
                res => {
                    dispatch(detailsSuccess(res.data));
                },
                error => {
                    if(error.response.status === 401){
                        window.location.href="/"
                    }
                    dispatch(detailsFailure(error));
                }
            );
    function detailsSuccess(data) { return { type: UserConstants.GET_DETAILS_SUCCESS, payload: data } }
    function detailsFailure(error) { return { type: UserConstants.GET_DETAILS_FAILURE, payload: error } }
}

export const profile_details = (id) => (dispatch) => {
    configAxios.get(`/employees/profile/${id}`)
        .then(
            res => {
                dispatch(detailsSuccess(res.data));
            },
            error => {
                if(error.response.status === 401){
                    window.location.href="/"
                }
                dispatch(detailsFailure(error));
            }
        );
function detailsSuccess(data) { return { type: UserConstants.PROFILE_DETAILS_SUCCESS, payload: data } }
function detailsFailure(error) { return { type: UserConstants.PROFILE_DETAILS_FAILURE, payload: error } }
}

export const manager_update = (req) => (dispatch) => {
    configAxios.post(`/employees/manager/update`,req)
        .then(
            res => {
                dispatch(updateSuccess(res));
            },
            error => {
                if(error.response.status === 401){
                    window.location.href="/"
                }
                dispatch(updateFailure(error));
            }
        );
function updateSuccess(data) { return { type: UserConstants.SET_MANAGER_SUCCESS, payload: data } }
function updateFailure(error) { return { type: UserConstants.SET_MANAGER_FAILURE, payload: error } }
}

export const change_manager = (req) => (dispatch) => {
    configAxios.post(`/employees/reporting/update`,req)
        .then(
            res => {
                dispatch(updateSuccess(res));
            },
            error => {
                if(error.response.status === 401){
                    window.location.href="/"
                }
                dispatch(updateFailure(error));
            }
        );
function updateSuccess(data) { return { type: UserConstants.CHANGE_MANAGER_SUCCESS, payload: data } }
function updateFailure(error) { return { type: UserConstants.CHANGE_MANAGER_FAILURE, payload: error } }
}

export const change_team = (req) => (dispatch) => {
    configAxios.post(`/employees/team/update`,req)
        .then(
            res => {
                dispatch(changeSuccess(res));
            },
            error => {
                if(error.response.status === 401){
                    window.location.href="/"
                }
                dispatch(changeFailure(error));
            }
        );
function changeSuccess(data) { return { type: UserConstants.CHANGE_TEAM_SUCCESS, payload: data } }
function changeFailure(error) { return { type: UserConstants.CHANGE_TEAM_FAILURE, payload: error } }
}
